export default __webpack_public_path__ + "static/media/1793.f02c4af0.png";